import { Check, CirclePlus } from 'lucide-react';
import type { CatalogOption } from '../data/mockOnboardingCatalog';

interface SignalCardsProps {
  options: CatalogOption[];
  selected: string[];
  onToggle: (id: string) => void;
}

export default function SignalCards({ options, selected, onToggle }: SignalCardsProps) {
  return (
    <div
      className="grid grid-cols-2 gap-3 sm:grid-cols-3 sm:gap-4.5"
      role="group"
      aria-label="Signals"
    >
      {options.map((option) => {
        const isSelected = selected.includes(option.id);
        return (
          <button
            key={option.id}
            type="button"
            role="checkbox"
            aria-checked={isSelected}
            onClick={() => onToggle(option.id)}
            className={`relative flex w-full items-center rounded-lg border border-transparent px-3 py-3 text-left transition-colors duration-150 sm:px-3.5 sm:py-3.5 ${
              isSelected
                ? 'bg-white text-gray-900 ring-2 ring-inset ring-gray-600'
                : 'bg-background text-gray-900 ring-1 ring-inset ring-gray-200 hover:ring-gray-300'
            }`}
          >
            <span className="min-w-0 flex-1 pr-6">
              <span className="block truncate text-xs font-medium leading-tight sm:text-[13px]">
                {option.label}
              </span>
            </span>
            {isSelected ? (
              <span
                className="absolute right-2.5 top-1/2 flex h-4 w-4 -translate-y-1/2 items-center justify-center rounded-full bg-emerald-600 text-white"
                aria-hidden="true"
              >
                <Check className="h-2.5 w-2.5" strokeWidth={3} />
              </span>
            ) : (
              <span
                className="absolute right-2.5 top-1/2 flex h-5 w-5 -translate-y-1/2 items-center justify-center text-gray-400"
                aria-hidden="true"
              >
                <CirclePlus className="h-5 w-5" strokeWidth={2} />
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
